export default __webpack_public_path__ + "static/media/study-ark.34d71fcc.png";